<script setup>
import { computed } from 'vue'

/**
 * The component's inherited properties.
 */
const props = defineProps({
    /**
     * The current location of the load.
     *
     * @type {Object}
     */
    value: {
        type: Object,
        required: true,
    },

    /**
     * The current load.
     *
     * @type {Object}
     */
    load: {
        type: Object,
        required: true,
    },
})

/**
 * Determine if the current location has geo location.
 *
 * @return {Boolean}
 */
const hasGeoLocation = computed(() => {
    return props.value?.geo?.latitude && props.value?.geo?.longitude
})

/**
 * The location of the load.
 *
 * @return {String}
 */
const location = computed(() => {
    if (props.value.description) {
        return props.value.description
    }

    if (!hasGeoLocation.value) {
        return 'N/A'
    }

    return `${props.value.geo.latitude}, ${props.value.geo.longitude}`
})

/**
 * The truck url.
 *
 * @return {String}
 */
const url = computed(() => {
    const truckId = props.load?.truck?.id
    if (truckId) {
        return `/mapping/#/truck/${truckId}`
    }

    return ''
})
</script>

<template>
    <a
        data-test="geo-location"
        :href="url"
        target="_blank"
        class="font-semibold hover:underline"
    >
        {{ location }}
    </a>
</template>
